import { PaymentEstimateObject } from '@liscio/api';
import { Stack, Typography } from '@liscio/ui';
import { formatStringDate } from '@liscio/utils';

import { EditableEstimatedPaymentField } from '../EditableEstimatedPaymentField/EditableEstimatedPaymentField';

export const EditableQuarterInfo = ({
  amountInCents,
  dueDate,
  title,
  paymentEstimate,
  quarter,
  requestStatus,
  onSuccess,
}: {
  title: string;
  dueDate?: string | null;
  amountInCents?: number | null;
  paymentEstimate: PaymentEstimateObject;
  quarter: 'q1' | 'q2' | 'q3' | 'q4';
  requestStatus?: string;
  onSuccess?: () => void;
}) => {
  return (
    <Stack
      sx={(theme) => ({
        paddingRight: quarter === 'q4' ? 0 : theme.spacing(1),
        paddingLeft: quarter === 'q1' ? 0 : theme.spacing(1),
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
        [theme.breakpoints.down('sm')]: {
          paddingRight: 0,
          paddingLeft: 0,
        },
      })}
    >
      <Stack direction="row" alignItems="baseline" gap={0.5}>
        <Typography variant="body2" fontWeight={600}>{title}</Typography>
        <Typography variant="caption" color="text.secondary">
          {formatStringDate({
            dateString: dueDate,
            defaultPlaceholder: '-',
            outputFormat: 'LLL dd',
          })}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" gap={0.5} mt={0.5}>
        <Typography variant="body1" sx={{ fontWeight: 600 }}>
          $
        </Typography>
        <EditableEstimatedPaymentField
          amountInCents={amountInCents}
          paymentEstimate={paymentEstimate}
          quarter={quarter}
          requestStatus={requestStatus}
          onSuccess={onSuccess}
        />
      </Stack>
    </Stack>
  );
};
